import React from 'react';
import { settingsFunctions } from '../../../../../functions/settings';
import styles from './ButtonSelector.module.css'

function ButtonSelector({setAddObj}) {
    const { createButtonOptions } = settingsFunctions;
    const selectOptions = createButtonOptions();

    return (
        <div className={styles.container}>
            {selectOptions.length > 0 && 
                selectOptions.map((obj, i) => (
                    <button key={obj.ref + i} className={styles.btn} onClick={() => setAddObj(prev => ({...prev, type: obj, icon: obj.icon}))}>
                        <i className={`${obj.icon} fa-2x`}></i>
                        {obj.name}
                    </button>
                ))
            }
        </div>
    );
};

export default ButtonSelector;